import { render } from "./DownloadSection.vue?vue&type=template&id=1476d64a&scoped=true"
import script from "./DownloadSection.vue?vue&type=script&lang=ts"
export * from "./DownloadSection.vue?vue&type=script&lang=ts"

import "./DownloadSection.vue?vue&type=style&index=0&id=1476d64a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1476d64a"

export default script